import { Link } from "react-router-dom";

export function ItemSpritesheet({ item }) {
  const spriteData = item.placeObject ?? item.placeEntity;
  if (!spriteData) return null;

  const { id, image, itemHeight, itemWidth, frames, targetSurface, isSpritesheet } = spriteData;
  let creator, creatorusername;
  if (item.ugc) creator = item.ugc?.creator || null;
  creatorusername = item.ugc?.creatorname || null;

  return (
    <div className="mb-6 wiki-production">
      <div className="text-lg font-semibold mb-2 text-center">Spritesheet Preview</div>
      {isSpritesheet && (
        <div className="flex justify-center items-center overflow-hidden bg-[var(--search-bg)] rounded-lg border border-gray-200 w-fit mx-auto">
          <div
            className="relative"
            style={{
              width: `${itemWidth}px`,
              height: `${itemHeight}px`,
              backgroundImage: `url(${image})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "0 0",
              animation: `frameAnimation 2s steps(${frames}) infinite`,
              imageRendering: "pixelated",
            }}
          />
        </div>
      )}

      <div className="flex justify-center items-center overflow-auto bg-[var(--search-bg)] rounded-lg border border-gray-200 w-full h-full mx-auto">
        <div className="relative">
          <img src={image} alt={id} />
        </div>
      </div>

      <div className="mt-4 text-sm text-gray-700 space-y-1">
        <div>
          <span className="item-title">Dimensions:</span>{" "}
          <span className="item-details">
            W:{itemWidth} × H:{itemHeight}px
          </span>
        </div>
        {isSpritesheet && (
          <div>
            <span className="item-title">Frames:</span> <span className="item-details"> {frames}</span>
          </div>
        )}
        <div>
          <span className="item-title">Target Surface:</span> <span className="item-details"> {targetSurface?.join(", ") || "None"}</span>
        </div>
        <div>
          {creator && (
            <>
              <span className="item-title">Creator:</span>{" "}
              <span className="item-details">
                {" "}
                <Link to={`/lookup/players/${creator}`} target="_blank" rel="noreferrer">
                  {creatorusername}
                </Link>
              </span>
            </>
          )}
        </div>
      </div>

      <style>{`
        @keyframes frameAnimation {
          100% {
            background-position: -${itemWidth * frames}px 0;
          }
        }
      `}</style>
    </div>
  );
}
